import Phaser from 'phaser';
import dimensions from '../dimensions';
import utils from '../utils';
import sounds from '../sounds';
import DialogueBox from '../objects/DialogueBox';
import ScoreWindow from '../objects/ScoreWindow';
import GameState from '../states/Game';

export default class MissionState extends GameState {
    init() {
        super.init();

        if (this.mode == "beg") {
            this.time = GameConfig.beg_time;
        } else {
            this.time = GameConfig.adv_time;
        }

        this.script = Script["Mission" + this.game.currentMission + "Level" + (this.game.currentLevel + 1)];
        this.scriptNo = 0;
    }

    startGame() {
        sounds.missionMusic.play();
        this.accuracy = 100;
        this.speed = 0;
        this.count = 0;
        this.child = 0;
        this.hits = 0;
        this.misses = 0;
        this.problemLetters = {};

        this.HUD.visible = true;
        this.game.add.tween(this.HUD).from({ y: this.HUD.y - 50 }, 350, "Linear", true);
        this.game.add.tween(this.gameArea).to({ alpha: 1 }, 350, "Linear", true);

        this.inputCarrat.x = this.textToType.children[0].x + this.textToType.x - 1;
        this.inputCarrat.y = -155;

        this.game.time.events.loop(1000, function () {
            this.inputCarrat.visible = !this.inputCarrat.visible;
        }.bind(this));

        this.timer = this.game.time.create();
        this.timer.add(this.time * 1000, this.endGame, this);
        this.timer.start();

        this.setTime(this.timer.duration);
    }

    endGame() {
        this.timer = null;
        this.removeInput();

        let problemLetters = "";

        for (let i = 0; i < 3; i++) {
            let letter = "";
            for (var key in this.problemLetters) {
                if (this.problemLetters.hasOwnProperty(key)) {
                    if (letter === "" || this.problemLetters[letter] < this.problemLetters[key]) letter = key;
                }
            }

            if (letter !== "" && this.problemLetters[letter] !== 0) {
                this.problemLetters[letter] = 0;
                problemLetters += letter + ",";
            }
        }

        problemLetters = problemLetters.substring(0, problemLetters.length - 1);

        this.scoreWindow = new ScoreWindow(this.game, this.game.add.group(), "Mission");
        this.gameGroup.add(this.scoreWindow);

        this.accuracyText.text = "Accuracy: " + this.accuracy + "%";
        this.scoreWindow.showMission(this.accuracy, problemLetters, this.hits, this.speed);
    }

    pressKey(input) {
        switch (input.key) {
            case "Shift":
            case "Control":
            case "Tab":
            case "Alt":
            case "CapsLock":
                return;
        }

        // Check for specials
        if (this.textToType.text[this.count] == "\n") {
            this.count++;
            this.inputCarrat.x = this.textToType.children[this.child].x + this.textToType.x - 1;
            this.inputCarrat.y += 34;
            return;
        }

        if (this.textToType.text[this.count] == input.key) {
            this.textToType.children[this.child].alpha = 0.3;
            this.count++;
            this.child++;
            this.hits++;

            let time = this.time - this.timer.duration / 1000;
            this.speed = Math.ceil(this.hits / 5 * (60 / time));
            this.wpmText.text = "Speed: " + this.speed + " WPM";

            this.accuracy = Math.floor(this.hits * 100 / (this.hits + this.misses));
            this.accuracyText.text = "Accuracy: " + this.accuracy + "%";

            if (this.count === this.textToType.text.length) {
                this.endGame();
            }
        } else {
            this.misses++;

            if (this.textToType.text[this.count] !== " ") {
                if (this.problemLetters[this.textToType.text[this.count]]) this.problemLetters[this.textToType.text[this.count]]++;else this.problemLetters[this.textToType.text[this.count]] = 1;
            } else {
                this.count++;
                this.child++;
            }

            this.accuracy = Math.floor(this.hits * 100 / (this.hits + this.misses));
            this.accuracyText.text = "Accuracy: " + this.accuracy + "%";
        }

        if (this.textToType.children[this.child]) this.inputCarrat.x = this.textToType.children[this.child].x + this.textToType.x - 1;else this.inputCarrat.alpha = 0;

        if (this.textToType.text[this.count] == "\n") {
            this.inputCarrat.x = this.textToType.children[this.child - 1].x + this.textToType.x - 1 + this.textToType.children[this.child - 1].width;
        }
    }

    update() {
        if (this.timer) {
            this.setTime(this.timer.duration);
        }
    }

    setTime(time) {
        time = Math.ceil(time / 1000);

        let minutes = Math.floor(time / 60);
        let seconds = time % 60;

        if (seconds < 10) seconds = "0" + seconds;

        this.timeText.text = "Time: " + minutes + ":" + seconds;
    }

    createEnvironment() {
        this.letterGroup = this.game.add.group();
        this.gameGroup.add(this.letterGroup);

        this.letters = [];

        this.createHUD();

        this.gameArea = this.game.add.group();
        this.gameArea.alpha = 0;
        this.gameGroup.add(this.gameArea);
        this.gameArea.x = dimensions.gameWidth / 2;
        this.gameArea.y = dimensions.gameHeight / 2;

        let bg = this.game.add.sprite(0, 25, "sheet", "ui-box");
        bg.anchor.set(0.5);
        this.gameArea.add(bg);

        this.createTextToType();

        this.inputCarrat = this.game.add.graphics(0, 0);
        this.inputCarrat.beginFill(0xffffff, 1);
        this.inputCarrat.drawRect(-1, -14, 2, 28);
        this.inputCarrat.endFill();
        this.gameArea.add(this.inputCarrat);
    }

    createTextToType() {
        let text = "";

        for (let i = 0; i < GameConfig.word_count; i++) {
            for (let j = 0; j < this.game.rnd.integerInRange(3, 7); j++) {
                text += utils.random(this.currentSet);
            }

            text += " ";
        }

        text = text.trim();

        const passages = Passages["Mission" + this.game.currentMission + "Level" + (this.game.currentLevel + 1)],
              passage = passages instanceof Array && passages.length ? passages[Math.round(Math.random() * (passages.length - 1))] : passages;
        if (passage !== "") {
            text = passage;
        }

        // if (Passages["Mission" + this.game.currentMission + "Level" + (this.game.currentLevel + 1)] !== "")
        //     text = Passages["Mission" + this.game.currentMission + "Level" + (this.game.currentLevel + 1)];

        this.textToType = this.game.add.bitmapText(0, -165, "font-text", text, 25);

        let size = 0,
            lastSpace = 0,
            places = [];
        for (let i = 0; i < this.textToType.children.length; i++) {
            size += this.textToType.children[i].width;

            if (this.textToType.text[i] == " ") {
                lastSpace = i;
            }

            if (size > this.gameArea.width - 300) {
                size = 0;
                places.push(lastSpace);
                i = lastSpace + 1;
            }
        }

        // for (let i = places.length - 1; i >= 0; i--) {
        //     text = text.substr(0, places[i] - 1) + "\n"+ text.substr(places[i] + 1);
        // }

        for (let i = places.length - 1; i >= 0; i--) {
            text = text.substr(0, places[i]) + "\n" + text.substr(places[i] + 1);
        }

        this.textToType.text = text;

        this.textToType.anchor.set(0.5, 0);
        this.gameArea.add(this.textToType);
    }

    createHUD() {
        this.HUD = this.game.add.group();
        this.gameGroup.add(this.HUD);

        this.HUD.x = dimensions.gameWidth / 2;

        let background = this.game.add.graphics(0, 0);
        background.beginFill(0x000000, 1);
        background.drawRect(-dimensions.actualWidth / 2, 0, dimensions.actualWidth, 50);
        background.alpha = 0.9;
        background.endFill();

        this.wpmText = this.game.add.bitmapText(-dimensions.gameWidth / 2 + 10, 32, "font-ui", "Speed: 0 WPM", 30);
        this.timeText = this.game.add.bitmapText(0, 32, "font-ui", "Time: 0:00", 30);
        this.accuracyText = this.game.add.bitmapText(dimensions.gameWidth / 2 - 10, 32, "font-ui", "Accuracy: 100%", 30);

        this.wpmText.anchor.set(0, 0.5);
        this.accuracyText.anchor.set(1, 0.5);
        this.timeText.anchor.set(0.5);

        this.HUD.add(background);
        this.HUD.add(this.wpmText);
        this.HUD.add(this.timeText);
        this.HUD.add(this.accuracyText);

        this.HUD.visible = false;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/states/Mission.js
// module id = 148
// module chunks = 0